<template>
  <div>
    <list
      row-key="AccountId"
      ref="list"
      unit="账号"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      v-if="trendShow"
      urlHash="basedata/finance/account"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template> 
     
      <template slot="table">
       
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    IsSelect: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: true,
    }
   
  },
  data() {
    return {
      api: require("@/api/ba/account").default,
      params: {
        AccountName: "",
        Status: null,
      },
      trendShow: true,
    };
  },
  mounted(){
    
  },
  methods: {
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
   
      this.api.export(this.$refs.list.queryParams).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>